import { DestroyAjaxForm } from "mixs/base/form_ajax_mixin";
import { validations }  from "apps/actions/validations";
import { destroy }         from "apps/actions/common";
import serializeJSON    from 'utilities/serialize_json';
import Timelag          from 'utilities/timelag'
import { Global }       from 'mixs/orders/planner/model';

class FormDestroy extends DestroyAjaxForm {
  watch(){
    super.watch();
  }
  public onChangeStore(newVal: any, oldVal: any, objectPath: string){
    super.onChangeStore(newVal, oldVal, objectPath);
    if(!newVal){ return; }
    if(oldVal && newVal.action == oldVal.action){ return; }
    this.submit();
  }
}

riot.mixin('forms.schedules.destroy', FormDestroy as riot.TagMixin);
